import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportCallsData } from "../../../../models/FacilityReportData";
import { LineChart } from "../../../AnalysisCollectionsComponents/CollectionChartArea/LineChart";
import { EditableAISummary } from "../EditableAISummary";

interface ICallsSectionProps {
  calls?: FacilityReportCallsData;
  isDownloading: boolean;
  facilityReportId: string;
}

export const CallsSection: React.FunctionComponent<ICallsSectionProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportDetails.${key}`);
  const { calls, isDownloading, facilityReportId } = props;

  const [timeUnit, setTimeUnit] = useState<"day" | "week" | "month">(
    calls?.time_unit ?? "day"
  );

  if (!calls) {
    return null;
  }

  return (
    <div className="calls-section white-border-panel facility-report-details-section">
      <div
        className="inner-container"
        id="facility-report-details-calls-section"
      >
        <EditableAISummary
          title={t("callsSection.title")}
          summary={calls.ai_summary}
          facilityReportId={facilityReportId}
          patchKey="calls"
          isDownloading={isDownloading}
        />
        {!calls.call_clicks_data ? (
          <p className="no-data-message">{t("no_data")}</p>
        ) : (
          <>
            <LineChart
              chartDetailsData={calls.call_clicks_data}
              usePrevYear={false}
              timeUnit={timeUnit}
              skipLabelTranslation={false}
              setTimeUnit={setTimeUnit}
              showTimeUnitSelect={!isDownloading}
            />
          </>
        )}
      </div>
    </div>
  );
};
